import React from 'react';
import { withTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { updateQuestion } from '../actions/';
import configData from "../../../Config/QuestionLevel.json";
import api from '../../../../api/api';
import AIChatModal from './AIChatModal';

class Info extends React.Component {

    state = {
        QuestionId: 0,
        title: '',
        Position: false,
        IsRelativeToTopic: null,
        first: true,
        Level: '',
        errorList: [],
        topicsCategories: [],
        textTypesList: [],
        dimensionComponentsList: [],
        elementsList: [],
        skillDimensionsMap: {},
        showDropdown: false,
        searchTerm: '',
        expandedCategories: [],
        showAiChatModal: false
    };

    constructor(props) {
        super(props);
        this._editor = new React.createRef();
        this.treeSelectRef = React.createRef();
        this.QuestionLevel = configData.QuestionLevel;
    }

    static getDerivedStateFromProps(props, state) {
        state.QuestionId = props.QuestionId;
        state.title = props.title;
        state.Level = props.Level;
        state.Mark = props.mark;
        state.Position = props.Position;
        state.IsRelativeToTopic = props.IsRelativeToTopic;

        if (state.title && state.first) {
            state.first = false;
            setTimeout(() => {
                try {
                    if (window.createRedactor && document.querySelector("#QuestionTitle")) {
                        window.createRedactor("#QuestionTitle", state.title);
                    }
                } catch (e) {
                    console.warn("Redactor create error:", e);
                }
            }, 400);
        }
        return state;
    }

    fetchQuestionSkills = (questionId) => {
        if (!questionId || questionId <= 0) return;
        api.get(`/QuestionsLookups/Questions/${questionId}/Skills`)
            .then(res => {
                if (Array.isArray(res.data?.data) && res.data.data.length > 0) {
                    this.props.setTopicIds(res.data.data);
                }
                if (Array.isArray(res.data?.details)) {
                    const map = {};
                    res.data.details.forEach(item => {
                        if (item.SkillId > 0) {
                            map[item.SkillId] = {
                                TextTypeId: item.TextTypeId || '',
                                DimensionComponentId: item.DimensionComponentId || '',
                                ElementId: item.ElementId || ''
                            };
                        }
                    });
                    this.setState({ skillDimensionsMap: map });
                }
            })
            .catch(err => console.error("Error fetching question skill details:", err));
    };

    componentDidMount() {
        setTimeout(() => {
            try {
                if (this.state.QuestionId === 0 && window.createRedactor && document.querySelector("#QuestionTitle")) {
                    window.createRedactor("#QuestionTitle", "");
                }
            } catch (e) {
                console.warn("Redactor mount error:", e);
            }
        }, 700);

        document.addEventListener("mousedown", this.handleClickOutside);

        api.get('/QuestionsLookups/SkillsCategories')
            .then(res => {
                let data = [];
                if (Array.isArray(res.data?.data)) {
                    data = res.data.data;
                } else if (Array.isArray(res.data?.data?.data)) {
                    data = res.data.data.data;
                }
                this.setState({
                    topicsCategories: data
                });
            })
            .catch(err => {
                console.error("Error fetching topics:", err);
            });

        api.get('/QuestionsLookups/CategoriesList?groupBy=TextTypes')
            .then(res => this.setState({ textTypesList: res.data?.data || [] }))
            .catch(err => console.error("Error fetching text types:", err));

        api.get('/QuestionsLookups/CategoriesList?groupBy=DimensionComponents')
            .then(res => this.setState({ dimensionComponentsList: res.data?.data || [] }))
            .catch(err => console.error("Error fetching dimension components:", err));

        api.get('/QuestionsLookups/CategoriesList?groupBy=Elements')
            .then(res => this.setState({ elementsList: res.data?.data || [] }))
            .catch(err => console.error("Error fetching elements:", err));

        const qId = this.props.QuestionId || this.state.QuestionId || this.props.question?.id || this.props.question?.question?.Id;
        this.fetchQuestionSkills(qId);
    }

    componentDidUpdate(prevProps) {
        const currentQId = this.props.QuestionId || this.props.question?.id || this.props.question?.question?.Id;
        const prevQId = prevProps.QuestionId || prevProps.question?.id || prevProps.question?.question?.Id;
        if (currentQId && currentQId !== prevQId) {
            this.fetchQuestionSkills(currentQId);
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.treeSelectRef.current && !this.treeSelectRef.current.contains(event.target)) {
            this.setState({ showDropdown: false });
        }
    }

    toggleDropdown = () => {
        this.setState({ showDropdown: !this.state.showDropdown });
    }

    handleSearchChange = e => {
        this.setState({ searchTerm: e.target.value });
    }

    toggleCategory = (categoryId) => {
        const expanded = [...this.state.expandedCategories];
        if (expanded.includes(categoryId)) {
            this.setState({ expandedCategories: expanded.filter(id => id !== categoryId) });
        } else {
            expanded.push(categoryId);
            this.setState({ expandedCategories: expanded });
        }
    }

    isCategoryExpanded = (categoryId) => {
        if (this.state.searchTerm) return true;
        return this.state.expandedCategories.includes(categoryId);
    }

    handleTopicToggle = (topicId) => {
        let currentTopicIds = [...(this.props.SkillIds || this.props.TopicIds || [])];
        let map = { ...this.state.skillDimensionsMap };
        if (currentTopicIds.includes(topicId)) {
            currentTopicIds = currentTopicIds.filter(id => id !== topicId);
            delete map[topicId];
        } else {
            currentTopicIds.push(topicId);
            map[topicId] = map[topicId] || { TextTypeId: '', DimensionComponentId: '', ElementId: '' };
        }
        this.setState({ skillDimensionsMap: map });
        if (typeof this.props.setSkillIds === 'function') this.props.setSkillIds(currentTopicIds);
        if (typeof this.props.setTopicIds === 'function') this.props.setTopicIds(currentTopicIds);

        var copy = this.props.question;
        if (copy && copy.question) {
            copy.question = {
                ...copy.question,
                Skills: currentTopicIds,
                Topics: currentTopicIds
            }
            this.props.updateQuestion(copy);
        }
    }

    handleSkillDimensionChange = (skillId, field, value) => {
        this.setState(prevState => ({
            skillDimensionsMap: {
                ...prevState.skillDimensionsMap,
                [skillId]: {
                    ...(prevState.skillDimensionsMap[skillId] || {}),
                    [field]: value
                }
            }
        }));
    }

    handleInsertAiHtml = (html, append = false) => {
        let finalHtml = html;
        if (append && window.getRedactor) {
            const current = window.getRedactor("#QuestionTitle") || "";
            finalHtml = current ? `${current}<br/>${html}` : html;
        }

        if (window.setRedactor) {
            window.setRedactor("#QuestionTitle", finalHtml);
        } else if (window.createRedactor) {
            window.createRedactor("#QuestionTitle", finalHtml);
        } else if (this._editor && this._editor.current) {
            this._editor.current.value = finalHtml;
        }
    };

    renderField = ({
        input,
        title,
        type,
        defaultValue,
        id,
        placeholder,
        meta: { touched, error }
    }) => (
        <div className="modern-input-wrapper">
            <input {...input} id={id} value={defaultValue} title={title} placeholder={placeholder} type={type} autoComplete="off" className={`form-control ${(touched && error) ? 'is-invalid' : ''}`} />
            {touched && error && <div className="invalid-feedback">{error}</div>}
        </div>
    );

    validateQuestionMark = value => {
        const { t } = this.props;
        if (!value || value <= 0) {
            return t('Pages.Lessons.Questions.forms.QuestionMark.placeholder');
        }
    }

    setMarkValue = value => {
        this.setState({
            Mark: value
        });
        this.props.setMark(value);
        var copy = this.props.question;
        copy.question = {
            ...copy.question,
            Mark: value
        }
        this.props.updateQuestion(copy);
    }

    setLevel = value => {
        var index = value.nativeEvent.target.selectedIndex;
        let Level = parseInt(value.nativeEvent.target.value);
        this.setState({
            Level: Level
        });
        this.props.setLevel(Level);
        var copy = this.props.question;
        copy.question = {
            ...copy.question,
            Level: {
                Id: Level,
                Name: value.nativeEvent.target[index].text
            }
        }
        this.props.updateQuestion(copy);
    }

    setPosition = value => {
        this.setState({
            Position: value
        });
        this.props.setPosition(value);
        var copy = this.props.question;
        copy.question = {
            ...copy.question,
            Position: value
        }
        this.props.updateQuestion(copy);
    }

    setIsRelativeToTopic = value => {
        this.setState({
            IsRelativeToTopic: value
        });
        this.props.setIsRelativeToTopic(value);
        var copy = this.props.question;
        if (copy && copy.question) {
            copy.question = {
                ...copy.question,
                IsRelativeToTopic: value
            }
            this.props.updateQuestion(copy);
        }
    }

    renderQuestionLevel() {
        return this.QuestionLevel.map(level => {
            return <option key={level.value} value={level.value}  > {level.label}</option >;
        });
    }

    submitMainInfo = () => {
        const { t } = this.props;
        var QuestionTitle = window.getRedactor("#QuestionTitle");

        var errors = this.validate(this.state.Mark, QuestionTitle);
        if (errors.length !== 0) {
            var errorList = errors.map((error, index) => {
                return <li key={`error-${index}`}>{error.placeholder}.</li>;
            });
            this.setState({ errorList: errorList });

            this.props.toast.error(t('Error.AllInformationIsRequired.Body'), {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } else {
            this.setState({ errorList: [] });

            const skillDetails = (this.props.TopicIds || []).map(skillId => {
                const dims = this.state.skillDimensionsMap[skillId] || {};
                return {
                    SkillId: skillId,
                    TextTypeId: dims.TextTypeId ? parseInt(dims.TextTypeId) : null,
                    DimensionComponentId: dims.DimensionComponentId ? parseInt(dims.DimensionComponentId) : null,
                    ElementId: dims.ElementId ? parseInt(dims.ElementId) : null
                };
            });

            this.props.submitMainInfo(
                QuestionTitle,
                this.state.Mark,
                this.Level ? this.Level.value : 1,
                this.props.Position,
                this.state.IsRelativeToTopic,
                this.props.TopicIds,
                skillDetails
            );
        }
    }

    validate(Mark = '', QuestionTitle = '') {
        const { t, typeId } = this.props;
        const errors = [];

        if (typeId !== 11 && (Mark.length === 0 || Mark <= 0)) {
            errors.push({ placeholder: t('Pages.Lessons.Questions.forms.QuestionMark.placeholder'), name: 'Mark' });
        }
        if (QuestionTitle.length === 0) {
            errors.push({ placeholder: t('Pages.Lessons.Questions.forms.QuestionTitle.placeholder'), name: 'QuestionTitle' });
        }
        return errors;
    }

    render() {
        const { t } = this.props;

        const rawCategories = Array.isArray(this.state.topicsCategories)
            ? this.state.topicsCategories
            : (Array.isArray(this.state.topicsCategories?.data) ? this.state.topicsCategories.data : []);

        const selectedCategoriesList = [];
        let totalSelectedCount = 0;
        rawCategories.forEach(cat => {
            if (cat && cat.Topics && Array.isArray(cat.Topics)) {
                const matchedSelected = cat.Topics.filter(topic =>
                    (this.props.TopicIds || []).includes(topic.TopicId)
                );
                if (matchedSelected.length > 0) {
                    totalSelectedCount += matchedSelected.length;
                    selectedCategoriesList.push({
                        CategoryId: cat.CategoryId,
                        CategoryName: cat.CategoryName,
                        Topics: matchedSelected
                    });
                }
            }
        });

        const filteredCategories = rawCategories.map(cat => {
            const matchedTopics = (cat.Topics || []).filter(t =>
                t.TopicName.toLowerCase().includes(this.state.searchTerm.toLowerCase())
            );
            return { ...cat, Topics: matchedTopics };
        }).filter(cat => cat.Topics.length > 0);

        return (
            <div className="modern-info-container">
                <div className={`modern-error-alert ${this.state.errorList.length === 0 ? 'd-none' : ''}`} role="alert">
                    <div className="modern-error-title">
                        <i className="fal fa-exclamation-circle ml-2"></i>
                        {t('Error.AllInformationIsRequired.Title') || 'الرجاء ملء كافة الحقول المطلوبة'}
                    </div>
                    <ul className="modern-error-list">
                        {this.state.errorList}
                    </ul>
                </div>

                {(!this.props.currentStep || this.props.currentStep === 1) && (
                    <div className="step-1-wrapper">
                        <div className="modern-form-section">
                    <div className="modern-section-title">
                        <i className="icon fal fa-text"></i>
                        {
                            this.props.isForGame ?
                                t('Pages.Games.forms.LessonInfo.QuestionInfo')
                                :
                                t('Pages.Lessons.Questions.forms.Info')
                        }
                    </div>
                    <div className="form-group w-100 mb-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <label className="modern-label mb-0" htmlFor="QuestionTitle">
                                {
                                    this.props.isForGame ?
                                        t('Pages.Games.forms.LessonInfo.QuestionInfo')
                                        :
                                        t('Pages.Lessons.Questions.forms.QuestionTitle.title')
                                }
                            </label>
                            <button
                                type="button"
                                className="btn-open-ai-chat w-auto"
                                style={{ width: 'auto' }}
                                onClick={() => this.props.onOpenAiMode ? this.props.onOpenAiMode() : this.setState({ showAiChatModal: true })}
                                title="صياغة وتنسيق نص الدرس بالذكاء الاصطناعي"
                            >
                                <i className="fal fa-sparkles"></i>
                                <span>شات صياغة نص الدرس ✨</span>
                            </button>
                        </div>
                        <textarea id="QuestionTitle" autoComplete="off" placeholder={t('Pages.Lessons.Questions.forms.QuestionTitle.placeholder')} className="form-control" ref={this._editor} ></textarea>
                    </div>

                    {
                        this.props.isForGame && (
                            <div className="w-100 mt-4">
                                <label className="modern-label">
                                    <i className="icon fal fa-gamepad"></i> {t('Pages.Games.forms.LessonInfo.Type') || 'نوع سؤال اللعبة:'}
                                </label>
                                <div className="toggle-cards-group">
                                    <div
                                        className={`toggle-card ${this.state.Position ? 'active-primary' : ''}`}
                                        onClick={() => this.setPosition(true)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Games.forms.LessonInfo.IsForFun')}</span>
                                        </div>
                                        <i className="icon fa-regular fa-gamepad-modern toggle-card-icon"></i>
                                    </div>
                                    <div
                                        className={`toggle-card ${!this.state.Position ? 'active-primary' : ''}`}
                                        onClick={() => this.setPosition(false)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Games.forms.LessonInfo.IsQuestion')}</span>
                                        </div>
                                        <i className="icon fa-regular fa-block-question toggle-card-icon"></i>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>

                {
                    this.props.typeId !== 11 && (
                        <div className="modern-form-section">
                            <div className="modern-section-title">
                                <i className="icon fal fa-sliders-h"></i>
                                {t('Pages.Lessons.Questions.forms.tools.Settings') || 'إعدادات العلامات والصعوبة'}
                            </div>
                            <div className="modern-grid">
                                <div className="form-group mb-0 w-100">
                                    <label className="modern-label" htmlFor="Mark">
                                        <i className="icon fas fa-tally"></i>
                                        {
                                            this.state.Position ?
                                                t('Pages.Games.forms.LessonInfo.TryCount')
                                                :
                                                t('Pages.Lessons.Questions.forms.QuestionMark.title')
                                        }
                                    </label>
                                    <Field
                                        ref={Mark => this.Mark = Mark}
                                        id="Mark"
                                        name="Mark"
                                        component={this.renderField}
                                        defaultValue={this.state.Mark}
                                        type="number"
                                        required={true}
                                        onChange={e => this.setMarkValue(e.target.value)}
                                        validate={this.validateQuestionMark}
                                        placeholder={this.state.Position ? t('Pages.Games.forms.LessonInfo.TryCountInfo') : t('Pages.Lessons.Questions.forms.QuestionMark.placeholder')}
                                        title={this.state.Position ? t('Pages.Games.forms.LessonInfo.TryCount') : t('Pages.Lessons.Questions.forms.QuestionMark.title')}
                                    />
                                </div>
                                <div className="form-group mb-0 w-100">
                                    <label className="modern-label" htmlFor="Level">
                                        <i className="icon fas fa-water-rise"></i>
                                        {t('Pages.Lessons.Questions.forms.QuestionLevel.title')}
                                    </label>
                                    <div className="modern-input-wrapper">
                                        <select
                                            id="Level"
                                            className="form-control"
                                            required={true}
                                            ref={Level => this.Level = Level}
                                            value={this.state.Level}
                                            onChange={e => this.setLevel(e)}
                                            placeholder={t('Pages.Lessons.Questions.forms.QuestionLevel.placeholder')}
                                            title={t('Pages.Lessons.Questions.forms.QuestionLevel.title')}>
                                            {this.renderQuestionLevel()}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    !(this.props.isForGame || this.props.type === "SelfDevelopment") && (
                        <div className="modern-form-section">
                            <div className="modern-section-title">
                                <i className="icon fal fa-laptop-code"></i>
                                {t('Pages.Lessons.Questions.forms.tools.LayoutAndRelativity') || 'تنسيق العرض والارتباط'}
                            </div>

                            <div className="w-100 mb-4">
                                <label className="modern-label">
                                    <i className="icon fal fa-arrows-h"></i> {t('Pages.Lessons.Questions.forms.tools.position') || 'موضع السؤال في الصفحة:'}
                                </label>
                                <div className="toggle-cards-group">
                                    <div
                                        className={`toggle-card ${this.state.Position ? 'active-success' : ''}`}
                                        onClick={() => this.setPosition(true)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Lessons.Questions.forms.tools.positionRight')}</span>
                                            <span className="toggle-card-desc">{t('Pages.Lessons.Questions.forms.tools.positionRightDesc') || 'عرض السؤال على الجانب الأيمن'}</span>
                                        </div>
                                        <i className="icon fad fa-arrow-alt-from-left toggle-card-icon"></i>
                                    </div>
                                    <div
                                        className={`toggle-card ${!this.state.Position ? 'active-success' : ''}`}
                                        onClick={() => this.setPosition(false)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Lessons.Questions.forms.tools.positionLeft')}</span>
                                            <span className="toggle-card-desc">{t('Pages.Lessons.Questions.forms.tools.positionLeftDesc') || 'عرض السؤال على الجانب الأيسر'}</span>
                                        </div>
                                        <i className="icon fad fa-arrow-alt-from-right toggle-card-icon"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="w-100">
                                <label className="modern-label">
                                    <i className="icon fal fa-sitemap"></i> {t("QuestionView.isRelativeToTopic") || "ارتباط السؤال بالنص (تحديد نوع الارتباط):"}
                                </label>
                                <div className="toggle-cards-group">
                                    <div
                                        className={`toggle-card ${this.state.IsRelativeToTopic === true ? 'active-info' : ''}`}
                                        onClick={() => this.setIsRelativeToTopic(true)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t("QuestionView.general") || "عام (مستقل)"}</span>
                                            <span className="toggle-card-desc">{t("QuestionView.generalOption") || "لا يتطلب قراءة نص الدرس للإجابة عليه"}</span>
                                        </div>
                                        <i className="icon fal fa-shield-check toggle-card-icon"></i>
                                    </div>
                                    <div
                                        className={`toggle-card ${this.state.IsRelativeToTopic === false ? 'active-info' : ''}`}
                                        onClick={() => this.setIsRelativeToTopic(false)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t("QuestionView.relativeToText") || "مرتبط بالنص"}</span>
                                            <span className="toggle-card-desc">{t("QuestionView.relativeToTextOption") || "يتطلب قراءة نص الدرس للإجابة عليه"}</span>
                                        </div>
                                        <i className="icon fal fa-book-reader toggle-card-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}

                {(!this.props.currentStep || this.props.currentStep === 2) && (
                    <div className="modern-form-section">
                    <div className="modern-section-title">
                        <i className="icon fal fa-sitemap"></i>
                        {t("QuestionView.skillsSection") || "المهارات التعليمية المرتبطة"}
                    </div>
                    <div className="form-group w-100 mb-0">
                        <label className="modern-label">
                            {t("QuestionView.skills") || "مهارات السؤال:"}
                        </label>
                        <div className="modern-tree-select-wrapper" ref={this.treeSelectRef}>
                            <div className="modern-tree-select-trigger" onClick={this.toggleDropdown}>
                                <div className="modern-tree-select-values">
                                    {totalSelectedCount > 0
                                        ? `${t('QuestionView.selectedSkillsList') || 'المهارات المختارة'} (${totalSelectedCount})`
                                        : (t('QuestionView.selectSkills') || 'اختر المهارات...')}
                                </div>
                                <i className={`fad fa-chevron-down arrow-icon ${this.state.showDropdown ? 'open' : ''}`}></i>
                            </div>
                            {this.state.showDropdown && (
                                <div className="modern-tree-select-dropdown">
                                    <div className="modern-tree-search-wrapper">
                                        <input
                                            type="text"
                                            className="form-control modern-search-input"
                                            placeholder={t('QuestionView.searchSkills') || "بحث في المهارات..."}
                                            value={this.state.searchTerm}
                                            onChange={this.handleSearchChange}
                                            onClick={e => e.stopPropagation()}
                                        />
                                        <i className="fal fa-search search-icon"></i>
                                    </div>
                                    <div className="modern-tree-nodes">
                                        {filteredCategories.map(cat => (
                                            <div key={cat.CategoryId} className="modern-tree-category">
                                                <div className="modern-category-header" onClick={() => this.toggleCategory(cat.CategoryId)}>
                                                    <i className={`far ${this.isCategoryExpanded(cat.CategoryId) ? 'fa-folder-open' : 'fa-folder'} category-folder-icon`}></i>
                                                    <span className="category-name">{cat.CategoryName}</span>
                                                    <span className="category-badge">{cat.Topics.length}</span>
                                                    <i className={`fal fa-chevron-down category-chevron ${this.isCategoryExpanded(cat.CategoryId) ? 'expanded' : ''}`}></i>
                                                </div>
                                                {this.isCategoryExpanded(cat.CategoryId) && (
                                                    <div className="modern-category-children">
                                                        {cat.Topics.map(topic => (
                                                            <label key={topic.TopicId} className="modern-tree-item" onClick={e => e.stopPropagation()}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={(this.props.TopicIds || []).includes(topic.TopicId)}
                                                                    onChange={() => this.handleTopicToggle(topic.TopicId)}
                                                                />
                                                                <span className="checkbox-custom"></span>
                                                                <span className="topic-name">{topic.TopicName}</span>
                                                                {topic.QuestionCount > 0 && (
                                                                    <span className="topic-question-count">({topic.QuestionCount} {t('QuestionView.questionsCount')})</span>
                                                                )}
                                                            </label>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {selectedCategoriesList.length > 0 && (
                            <div className="selected-topics-tags-list mt-3">
                                <div className="selected-topics-label">
                                    <i className="far fa-tags ml-1"></i>
                                    {t("QuestionView.selectedSkillsList") || "المهارات المختارة:"}
                                </div>
                                <div className="selected-categories-container">
                                    {selectedCategoriesList.map(cat => (
                                        <div key={cat.CategoryId} className="selected-category-group mb-2">
                                            <div className="selected-category-header-title">
                                                <i className="far fa-folder-open ml-1 text-primary"></i>
                                                <span className="category-group-name">{cat.CategoryName}</span>
                                                <span className="selected-category-badge">({cat.Topics.length})</span>
                                            </div>
                                            <div className="selected-tags-container">
                                                {cat.Topics.map(topic => {
                                                    const topicId = topic.TopicId;
                                                    const skillDims = this.state.skillDimensionsMap[topicId] || {};

                                                    return (
                                                        <div key={topicId} className="selected-skill-card border rounded p-3 mb-3 bg-white shadow-sm w-100">
                                                            <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                                                                <div className="font-weight-bold text-primary" style={{ fontSize: '0.95rem' }}>
                                                                    <i className="far fa-bookmark ml-1"></i>
                                                                    <span>{topic.TopicName}</span>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1"
                                                                    style={{ borderRadius: '6px', width: 'auto' }}
                                                                    title={t('Cancel') || 'حذف'}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        this.handleTopicToggle(topicId);
                                                                    }}
                                                                >
                                                                    <i className="far fa-times ml-1"></i>
                                                                    <span>إزالة</span>
                                                                </button>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-4 mb-2">
                                                                    <label className="small text-muted mb-1 d-block font-weight-bold">
                                                                        <i className="fal fa-file-alt ml-1"></i>
                                                                        {t("TextType") || "نوع النص (اختياري)"}
                                                                    </label>
                                                                    <select
                                                                        className="form-control form-control-sm"
                                                                        style={{ height: '36px', borderRadius: '6px', fontSize: '0.82rem' }}
                                                                        value={skillDims.TextTypeId || ''}
                                                                        onChange={(e) => this.handleSkillDimensionChange(topicId, 'TextTypeId', e.target.value)}
                                                                    >
                                                                        <option value="">-- {t("QuestionView.uncategorized") || "اختياري"} --</option>
                                                                        {this.state.textTypesList.map(item => (
                                                                            <option key={item.CategoryId} value={item.CategoryId}>{item.CategoryName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-4 mb-2">
                                                                    <label className="small text-muted mb-1 d-block font-weight-bold">
                                                                        <i className="fal fa-puzzle-piece ml-1"></i>
                                                                        {t("DimensionComponent") || "مكون البعد (اختياري)"}
                                                                    </label>
                                                                    <select
                                                                        className="form-control form-control-sm"
                                                                        style={{ height: '36px', borderRadius: '6px', fontSize: '0.82rem' }}
                                                                        value={skillDims.DimensionComponentId || ''}
                                                                        onChange={(e) => this.handleSkillDimensionChange(topicId, 'DimensionComponentId', e.target.value)}
                                                                    >
                                                                        <option value="">-- {t("QuestionView.uncategorized") || "اختياري"} --</option>
                                                                        {this.state.dimensionComponentsList.map(item => (
                                                                            <option key={item.CategoryId} value={item.CategoryId}>{item.CategoryName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-4 mb-2">
                                                                    <label className="small text-muted mb-1 d-block font-weight-bold">
                                                                        <i className="fal fa-cube ml-1"></i>
                                                                        {t("Element") || "العنصر (اختياري)"}
                                                                    </label>
                                                                    <select
                                                                        className="form-control form-control-sm"
                                                                        style={{ height: '36px', borderRadius: '6px', fontSize: '0.82rem' }}
                                                                        value={skillDims.ElementId || ''}
                                                                        onChange={(e) => this.handleSkillDimensionChange(topicId, 'ElementId', e.target.value)}
                                                                    >
                                                                        <option value="">-- {t("QuestionView.uncategorized") || "اختياري"} --</option>
                                                                        {this.state.elementsList.map(item => (
                                                                            <option key={item.CategoryId} value={item.CategoryId}>{item.CategoryName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

                <div className="form-group w-100 text-center mt-4">
                    <button className="premium-btn-save" title={t('Pages.Lessons.Questions.forms.tools.saveAndContinue')} type="button" onClick={() => this.submitMainInfo()}>
                        <i className="icon far fa-save"></i>
                        <span>
                            {
                                this.props.isForGame ?
                                    t('Pages.Games.forms.LessonInfo.saveAndContinue')
                                    :
                                    t('Pages.Lessons.Questions.forms.tools.saveAndContinue')
                            }
                        </span>
                    </button>
                </div>
                <AIChatModal
                    show={this.state.showAiChatModal}
                    onHide={() => this.setState({ showAiChatModal: false })}
                    onInsertHtml={this.handleInsertAiHtml}
                    topicsCategories={this.state.topicsCategories}
                    textTypesList={this.state.textTypesList}
                    dimensionComponentsList={this.state.dimensionComponentsList}
                    elementsList={this.state.elementsList}
                    TopicIds={this.props.TopicIds}
                    skillDimensionsMap={this.state.skillDimensionsMap}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        question: state.questions
    };
};

export default connect(mapStateToProps, { updateQuestion })(withTranslation('common')(Info));
